
import { 
  Card, 
  CardContent
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, Users, ArrowUp } from "lucide-react";

interface TimedPricingRecommendationProps {
  opportunity: {
    id: number;
    timeSlot: string;
    strategy: string;
    items: string[];
    discount: number;
    projectedSales: number;
    revenueImpact: number;
    customerIncrease: number;
  };
}

export const TimedPricingRecommendation = ({ opportunity }: TimedPricingRecommendationProps) => {
  return (
    <Card className="overflow-hidden border border-border">
      <CardContent className="p-3">
        <div className="space-y-2">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="font-semibold">{opportunity.strategy}</h3>
              <p className="text-xs text-muted-foreground flex items-center">
                <Clock className="inline h-3 w-3 mr-1" />
                {opportunity.timeSlot}
              </p>
            </div>
            {opportunity.discount > 0 ? (
              <Badge variant="outline" className="bg-green-100 text-green-800 border-green-300">
                {opportunity.discount}% off
              </Badge>
            ) : (
              <Badge variant="outline" className="bg-blue-100 text-blue-800 border-blue-300">
                Special menu
              </Badge>
            )}
          </div>

          <div className="text-xs">
            <p className="font-medium mb-1">Included items:</p>
            <p className="text-muted-foreground">{opportunity.items.join(', ')}</p>
          </div>

          <div className="flex justify-between text-xs pt-1">
            <div className="flex items-center">
              <Users className="h-3 w-3 mr-1" />
              <span className="text-green-600">+{opportunity.customerIncrease}</span>
            </div>
            <div>
              Revenue Impact: <span className="font-semibold">${opportunity.revenueImpact.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
